<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="cuenta-bancaria" titulo="Servicio financiero / Cuentas bancarias" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:1em;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 2rem 2rem !important; overflow:auto;" [style.height.px]="ctrl.tamano-160">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('bancos', 'banco'); "></a>

                    <div class="columns">
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Banco:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <div class="select">
                                        <select class="select" formControlName="bancos_id">
                                            <option *ngFor="let item of ctrl.bancos" value="{{item.id}}">{{item.nombre}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">No. Cuenta:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('no_cuenta').hasError('required') }" placeholder="No. Cuenta"
                                        formControlName="no_cuenta">
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('no_cuenta').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('no_cuenta').hasError('required') ">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Clabe:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('clabe').hasError('required') }" placeholder="Clabe"
                                        formControlName="clabe">
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clabe').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('clabe').hasError('required') ">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field">
                                <label class="label">Titular:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('titular').hasError('required') }" placeholder="Titular"
                                        formControlName="titular">
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('titular').hasError('required') ">
                                        <i class="fa fa-warning"></i>
                                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('titular').hasError('required') ">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>
